import pt from "./pt";
import en from "./en";
import ptbr from "./ptbr";

import ja from "./ja";
import zh from "./zh";
import hi from "./hi";
import es from "./es";
import ru from "./ru";
import ar from "./ar";
import fr from "./fr";
import it from "./it"; // Italiano
import de from "./de"; // Alemão

// 🔹 Centraliza todas as traduções disponíveis
const translations = {
  pt,
  en,
  "pt-br": ptbr,
  ja,
  zh,
  hi,
  es,
  ru,
  ar,
  fr,
  it,
  de,
};

// 🔹 Tenta pegar o idioma salvo no localStorage ou define "pt" como padrão
let currentLang =
  (localStorage.getItem("lang") as keyof typeof translations) || "pt";

// 🔹 Define idioma e salva no localStorage
export function setLang(lang: keyof typeof translations) {
  if (!translations[lang]) lang = "pt"; // fallback se for inválido
  currentLang = lang;
  localStorage.setItem("lang", lang);
  window.location.reload(); // recarrega para aplicar a tradução
}

// 🔹 Retorna idioma atual
export function getLang(): keyof typeof translations {
  return currentLang;
}

// 🔹 Função de tradução (aceita strings, objetos e variáveis)
export function t(path: string, vars?: Record<string, string>): any {
  const keys = path.split(".");
  let text: any = translations[currentLang];

  for (const key of keys) {
    text = text?.[key];
    if (text === undefined) return path; // fallback se não existir
  }

  // substituição de variáveis (ex: "Olá, {{nome}}")
  if (typeof text === "string" && vars) {
    return Object.keys(vars).reduce(
      (acc, v) => acc.replace(`{{${v}}}`, vars[v]),
      text
    );
  }

  return text; // pode retornar string ou objeto
}
